enum MediaFormats {
  Logo = 'logo',
  Masthead = 'masthead',
  Wallpaper = 'wallpaper',
  Question = 'question',
  Countdown = 'countdown',
  CTA = 'CTA',
  Interstitial = 'interstitial',
  SocialShare = 'socialShare',
  BottomBanner = 'bottomBanner',
  QRCode = 'qrCode',
};

export default MediaFormats;
